// https://github.com/benjamingr/RexExp.escape
var $def = require('./$.def');
$def($def.S, 'RegExp', {
  escape: require('./$.replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&', true)
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es7.regexp.escape.js
 ** module id = 86
 ** module chunks = 0
 **/